import type { FgaAssignableRelation } from './generated/model'

/** The workflow permission vocabulary a permission set configures. */
export const WORKFLOW_PERMISSIONS = ['create_request'] as const

export type WorkflowPermission = (typeof WORKFLOW_PERMISSIONS)[number]

export const workflowGrantsRelation = (
  permission: WorkflowPermission
): Extract<FgaAssignableRelation<'workflow_permission_set'>, `grants_${string}`> => `grants_${permission}`
